const options = {
    rootClass: 'zp-project-preview',
    initType: 1
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);
    const _d = $(d);

    class ProjectPreview {


        /**
         * Konstruktor
         * @param {Selector} root
         */
        constructor(root) {
            this.start(root);
        }


        /**
         * foo
         * @param {Selector} root
         */
        start(root) {



        }


    }

    return ProjectPreview;

}(window, document, jQuery)));